import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import routes from 'constants/routes';
import useMediaQuery from 'hooks/useMediaQuery';
import NotFoundIcon from 'styles/assets/404.svg';
import DeltaButton from 'UIKit/DeltaButton/DeltaButton';

import styles from './notFound.module.scss';

const NotFound = () => {
  const { t } = useTranslation(['errors']);
  const { whenBelowMd } = useMediaQuery();
  const history = useHistory();

  const redirectToHomepage = () => {
    const homePagePath = whenBelowMd ? routes.homepage.default : routes.webAppHome;
    history.push(homePagePath);
  };

  return (
    (<div
      className={cn('container', styles.notFoundContainer)}
      data-palette="NotFound">
      <div className={styles.textSection}>
        <h2 className={styles.errorCodeHeading}>404 {t('errors:error')}</h2>
        <h2 className={styles.pageNotFoundHeading}>{t('errors:pageNotFound')}..</h2>
        <h2 className={styles.errorDescription}>{t('errors:pageNotExist')}</h2>
        <div className={styles.buttonContainer}>
          <DeltaButton
            data-testid="back-to-homepage-button"
            onClick={redirectToHomepage}
            className={styles.button}
          >
            {t('errors:backToHomepage')}
          </DeltaButton>
        </div>
      </div>
      <img src={NotFoundIcon} alt="not-found" className={styles.errorImage} />
    </div>)
  );
};

export default NotFound;
